<template>
  <v-dialog :value.sync="value" v-bind="$attrs" v-on="$listeners" max-width="1024">
    <v-card class="grey lighten-4">
      <v-card-title class="primary mb-8">
        <div class="d-flex align-center">
          <v-icon left dark>mdi-plus-circle</v-icon>
          <span class="title white--text">{{ $t("PANEL.MEDIA.ADD_MEDIA.TITLE") }}</span>
        </div>
      </v-card-title>
      <v-card-text class="pb-0">
        <div id="mediaUpload">
          <div :class="eventDropClass" class="media-upload-container" @dragover="dragOver" @dragleave="dragLeave" @drop="dropFile" ref="containerMediaUpload">
            <div class="d-none">
              <input type="file" multiple name="mediaUpload" ref="inputMediaUpload" id="inputMediaUpload" :accept="accept.join()" @input="inputFile" />
            </div>
            <label for="inputMediaUpload" v-if="files.length == 0">
              <div class="media-upload-wrapper">
                <div>
                  <p class="title">{{ $t("PANEL.MEDIA.ADD_MEDIA.ADD_MEDIA_INFO") }}</p>
                  <p class="subtitle-1">ya da</p>
                  <v-btn color="primary" class="text-capitalize mb-8" ref="buttonMediaUpload" outlined @click="selectFile"
                    >{{ $t("PANEL.MEDIA.ADD_MEDIA.SELECT_FILE") }}
                  </v-btn>
                  <div class="text-caption">
                    {{
                      $t("PANEL.MEDIA.ADD_MEDIA.MAX_UPLOAD_SIZE_INFO", {
                        SIZE: 2,
                        FORMAT: "MB"
                      })
                    }}
                  </div>
                </div>
              </div>
            </label>
            <div v-else>
              <v-container>
                <v-row>
                  <v-col class="12" sm="3" :key="key" v-for="(file, key) in files">
                    <v-card elevation="3" class="rounded-lg overflow-hidden">
                      <v-card-text class="px-0 pt-0">
                        <file-thumbnailer :value="file" class="mb-2" />
                        <div class="px-3">
                          <b>{{ file.name }}</b>
                        </div>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <!-- <v-tooltip color="orange" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-on="on"
                              v-bind="attrs"
                              x-small
                              fab
                              color="orange darken-3"
                              class="mr-3"
                            >
                              <v-icon color="white">mdi-crop</v-icon>
                            </v-btn>
                          </template>
                          <span>Görüntüyü Kırp</span>
                        </v-tooltip> -->
                        <v-tooltip color="red" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-on="on" v-bind="attrs" x-small fab color="red darken-3" @click="removeFile(files.indexOf(file))">
                              <v-icon color="white">mdi-delete-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("PANEL.MEDIA.ADD_MEDIA.REMOVE_IMAGE_BTN") }}</span>
                        </v-tooltip>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-btn class="d-block mx-auto px-10 mb-5" color="primary" @click="uploadFiles" :loading="loading">
                      <v-icon left>mdi-upload-multiple</v-icon>
                      {{ $t("PANEL.MEDIA.ADD_MEDIA.UPLOAD_BTN") }}
                    </v-btn>
                    <v-progress-linear v-model="uploadProgress" v-show="loading" :value="55" :buffer-value="100" height="25" color="success">
                      <template v-slot:default="{ value }">
                        <strong>{{ $t("PANEL.MEDIA.ADD_MEDIA.UPLOADING_FILES", { NUMBER: Math.ceil(value) }) }}</strong>
                      </template>
                    </v-progress-linear>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-container class="d-flex">
          <v-spacer></v-spacer>
          <v-btn color="red lighten-5" depressed @click="$emit('input', false)">
            <v-icon left color="red">mdi-close</v-icon>
            <span class="red--text">{{ $t("PANEL.MEDIA.ADD_MEDIA.CLOSE_BTN") }}</span>
          </v-btn>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import FileThumbnailer from "./FileThumbnailer.vue";
import axios from "axios";

export default {
  components: { FileThumbnailer },
  name: "AddMedia",
  props: {
    value: {
      required: true,
      default: false
    }
  },
  data: () => ({
    eventDropClass: {
      "drop-active": false
    },
    files: [],
    preview: [],
    accept: [],
    loading: false,
    uploadProgress: 0
  }),
  computed: {
    ...mapState({
      acceptFilesList: state => state.Media.acceptFilesList
    })
  },
  methods: {
    fileChanged() {
      this.files = [...this.$refs.inputMediaUpload.files];
    },
    inputFile() {
      this.files = [...this.$refs.inputMediaUpload.files];
    },
    dropFile(e) {
      e.preventDefault();
      this.$refs.inputMediaUpload.files = e.dataTransfer.files;
      this.fileChanged(e);
      this.dragLeave(e);
    },
    dragOver(e) {
      e.preventDefault();
      this.$refs.containerMediaUpload.classList.add("drop-active");
    },
    dragLeave() {
      this.$refs.containerMediaUpload.classList.remove("drop-active");
    },
    selectFile() {
      this.$refs.inputMediaUpload.click();
    },
    removeFile(i) {
      if (this.files.length === 1) {
        this.$refs.inputMediaUpload.value = "";
      }
      this.files.splice(i, 1);
    },
    getImgSrc(img, key) {
      return new Promise(resolve => {
        var picReader = new FileReader();
        picReader.onload = image => resolve(image.target.result);
        picReader.readAsDataURL(img);
      }).then(data => {
        this.$set(this.preview, key, data);
      });
    },
    verifyUploadFiles(files) {
      let verify = true,
        self = this;
      files.forEach(file => {
        if (!self.accept.includes(file.type)) {
          verify = false;
        }
      });
      return verify;
    },
    uploadFiles() {
      return new Promise(resolve => {
        if (this.verifyUploadFiles(this.files)) {
          let formData = new FormData(),
            token = this.$store.state.User.UserLogin.token,
            methodName = "Api/Media/UploadImage",
            fileSizes = 0;

          this.files.forEach((file, key) => {
            formData.append(`imageFiles-${key}`, file);
            fileSizes += file.size;
          });
          formData.append("data[methodName]", methodName);

          this.loading = true;
          return axios({
            url: process.env.VUE_APP_API_URL,
            data: formData,
            method: "POST",
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
              Range: "bytes=0-" + fileSizes
            },
            onUploadProgress: e => {
              if (e.loaded <= fileSizes) {
                this.uploadProgress = Math.round((e.loaded / fileSizes) * 100);
              }

              if (e.loaded === e.total) {
                this.uploadProgress = 100;
              }
            }
          }).then(res => {
            let response = res.data;
            if (response.status === 200) {
              this.$snotify.success(this.$t("PANEL.MEDIA.NOTIFY.FILE_UPLOAD_SUCCESSFUL"), this.$t("PANEL.NOTIFY.SUCCESS"));
              this.files = [];
              this.$emit("input", false);
              this.$emit("added", this.files);
            } else {
              this.$snotify.error(response.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
            }
            resolve(res);
          });
        } else {
          resolve(this.$snotify.error(this.$t("PANEL.MEDIA.NOTIFY.INVALID_MIME_TYPE_ERROR"), this.$t("PANEL.NOTIFY.ERROR")));
        }
      })
        .then(() => {
          this.uploadProgress = 0;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(err => {
          this.$snotify.error(err, this.$t("PANEL.NOTIFY.ERROR"));
          this.loading = false;
        });
    }
  },
  created() {
    let self = this;
    this.$store.dispatch("Media/getAcceptFiles").then(res => {
      self.accept = res.data;
    });
  },
  mounted() {
    // this.$emit("input", true);
  },
  watch: {
    files(files) {
      let imgFiles = Object.assign(files, {}),
        self = this;

      imgFiles.forEach((file, key) => {
        // Dosya türü görüntü ise önizleme oluştur
        if (self.acceptFilesList.images.includes(file.type)) {
          this.getImgSrc(file, key);
        }
      });
    }
  }
};
</script>

<style>
/* #mediaUpload .media-upload-container {
} */
#mediaUpload .media-upload-wrapper {
  border: 2px dashed #333;
  padding: 3em 2em 1em;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  border-radius: 0.5em;
}

#mediaUpload .media-upload-wrapper p.title {
  margin-bottom: 0.3em;
}

#mediaUpload .media-upload-wrapper p.subtitle-1 {
  margin-bottom: 0.75em;
}

.drop-active {
  background-color: rgb(194, 255, 194);
}
</style>
